import { render } from "./Users.vue?vue&type=template&id=1e4791eb&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=1e4791eb&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4791eb"]])

export default __exports__